// Internal dependencies.
import { AvatarGroupTokenList } from './AvatarGroup.types';

export const AVAILABLE_TOKEN_LIST: AvatarGroupTokenList = [
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
  {
    name: 'Ethereum',
    imageSource: {
      uri: 'https://cryptologos.cc/logos/avalanche-avax-logo.png',
    },
  },
];

export const MAX_STACKED_AVATARS = 4;

export const STACKED_AVATARS_OVERFLOW_COUNTER_ID =
  'stacked-avatar-overflow-counter';
